import nymblLogoWhite from "@/assets/nymbl-logo-white.png";

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-[1.05fr_0.95fr]">
      {/* ============ LEFT — brand panel ============ */}
      <div
        className="relative hidden items-center justify-center overflow-hidden px-14 py-12 text-white lg:flex"
        style={{
          background:
            "linear-gradient(135deg, var(--brand-950) 0%, var(--brand-900) 55%, var(--ring) 100%)",
        }}
      >
        <div className="flex items-center gap-7">
          <img src={nymblLogoWhite} alt="Nymbl" className="block h-[72px] w-auto" />
          <span className="h-[56px] w-px bg-white/[0.32]" />
          <span className="font-display text-[28px] font-medium tracking-[0.22em] text-white/[0.82] uppercase">
            Staff
          </span>
        </div>
      </div>

      {/* ============ RIGHT — form panel ============ */}
      <div className="bg-background relative flex items-center justify-center px-6 py-6 lg:px-20 lg:py-6">
        <div className="w-full max-w-[380px]">{children}</div>
      </div>
    </div>
  );
}
